import { ReactNode, useState } from 'react'

import { AstraPopover } from '~/astra'
import { useReleaseNote } from '~/hooks/useReleaseNote'

import { type SupportView, UserSupportDialog } from './UserSupportDialog'
import { UserSupportMenu } from './UserSupportMenu'

type Props = {
    children: ReactNode
}

export const UserSupportPopoverMenu = ({ children }: Props) => {
    const [isPopoverOpen, setIsPopoverOpen] = useState(false)
    const [dialogView, setDialogView] = useState<SupportView | null>(null)
    const { newReleaseNote, setIsReleaseNotesDialogOpen } = useReleaseNote()

    const handleFormClick = (view: SupportView) => {
        setIsPopoverOpen(false)
        setDialogView(view)
    }

    const handleOpenReleaseNotes = () => {
        setIsPopoverOpen(false)
        setIsReleaseNotesDialogOpen(true)
    }

    return (
        <>
            <AstraPopover
                isOpen={isPopoverOpen}
                onOpenChange={setIsPopoverOpen}
                side="top"
                align="end"
                popoverContent={
                    <UserSupportMenu setActiveView={handleFormClick} onOpenReleaseNote={handleOpenReleaseNotes} releaseNoteIndicator={!!newReleaseNote} />
                }
            >
                <div>{children}</div>
            </AstraPopover>

            {dialogView && <UserSupportDialog activeView={dialogView} onClose={() => setDialogView(null)} />}
        </>
    )
}
